const selectData = (state) => state.settings.mailboxProtection.landings.data
const selectLoader = (state) => state.settings.mailboxProtection.landings.loader
const selectError = (state) => state.settings.mailboxProtection.landings.error

export { selectData, selectLoader, selectError }
